export enum InteractionTypes {
    SKIP = 'skip',
    SUBMIT = 'submit',
    SWITCH = 'switch',
    LANGUAGE = 'language',
    CUSTOM_SWITCH = 'custom-switch',
    LOGIN = 'login',
  }